import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import BakeasyTable from '../../components/tables/BakeasyTable';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import {
  downloadShippedOrders,
  fetchShippings,
  shippingsState,
} from '../../redux_store/slices/shippingsSlice';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { UNAUTHORIZED } from '../../constants/Constants';
import { authActions } from '../../redux_store/slices/authSlice';
import BakeasyTextFieldSearch from '../../components/textfields/BakeasyTextFieldSearch';
import {
  BakeasyButtonExport,
  BakeasyButtonFilter,
  BakeasyButtonPrint,
} from '../../components/buttons/BakeasyButton';
import BakeasyPaper from '../../components/common/BakesasyPaper';
import { BakeasyChip } from '../../components/common/BakeasyChip';
import { formatDateTime } from '../../utils/DateUtils';
import BakeasySelectedFilters from '../../components/common/BakeasySelectedFilters';
import { shippingTableHeaders } from '../../constants/TableHeaders';
import { deleteKeyFromObject, preparePayload } from '../../utils/commonUtils';
import { useDebouncedFetch } from '../../custom/useDebouncedCallback';

export const ShippingMemos: FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tableRef = React.useRef<any>();
  const fetchData = useDebouncedFetch();

  const isMobile = useMediaQuery('(max-width:600px)');
  let myContext = React.useContext(AppContext);

  const [shippingList, setShippingList] = useState<any[]>([]);
  const [ingredientList, setIngredientList] = useState<any[]>([]);
  const [selectedRecipe, setSelectedRecipe] = useState<string | null>(null);
  const recipeOptions = ['Food Prep', 'Bakery Prep'];
  const [generateClicked, setGenerateClicked] = useState<boolean>(false);
  const [productQuantity, setProductQuantity] = useState<any>('');
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const [search, setSearch] = useState<string>('');
  const [count, setCount] = React.useState<number>(0);
  const [tFilter, setTFilter] = React.useState<any>({});

  let { error, value, rowsPerPage, pageNo, filter } =
    useAppSelector(shippingsState);

  const refreshPageData = async (
    newPage: number,
    search?: string,
    filter?: {} | undefined
  ) => {
    let payload = await preparePayload(
      {
        limit: rowsPerPage,
        page: newPage + 1,
        sortBy: 'shippingId',
        sortDirection: -1,
      },
      filter,
      search,
      newPage
    );

    if (payload['sortBy'] === 'createdDate') {
      payload['sortBy'] = 'shippingId';
    }

    await dispatch(fetchShippings(payload));
    // await fetchData(fetchShippings, payload);
  };

  // useEffect(() => {
  //   return () => fetchData.cancel(); // Cancel debounce on component unmount to avoid memory leaks
  // }, [fetchData]);

  useEffect(() => {
    if (error === UNAUTHORIZED) {
      dispatch(authActions.logout());
    }
  }, [error]);

  useEffect(() => {
    if (value?.totalCount === -1) {
      refreshPageData(pageNo);
    } else {
      const filteredData: any = value?.data?.map((shipping: any) => {
        return {
          id: shipping?.id,
          name: shipping?.name,
          onShippingIdClick: () => {
            navigate('/shippingdetails', { state: { id: shipping?._id } });
          },
          order_Id: shipping?.orderId,
          shippingId: shipping?.shippingId,
          storePo: shipping?.poNumber,
          storeName: shipping?.storeName,
          totalPrice: parseFloat(shipping?.totalSumInshipping).toFixed(2),
          dueDate: shipping?.dueDate ? formatDateTime(shipping?.dueDate) : '',
          shippedDate: shipping?.shippedDate
            ? formatDateTime(shipping?.shippedDate)
            : '',
          status: <BakeasyChip label={shipping?.status} />,
        };
      });
      setShippingList(filteredData);
      setCount(value?.totalCount);
    }
  }, [value]);

  const handleDelete = async (key: any) => {
    // const newFilters = { ...tFilter };
    // delete newFilters[key];
    let newFilters = await deleteKeyFromObject(key, tFilter);
    setTFilter(newFilters);
    refreshPageData(pageNo - 1, search, newFilters);
  };

  function openFilterShippingConfirmDialog() {
    myContext.setConfirmDialog({
      type: 'invoice/shipping-filter',
      open: true,
      data: filter,
      title: t('SHIPPING_FILTER'),
      onYesClick: (event: any, param: string | undefined) => {
        setTFilter(param);
        refreshPageData(0, search, param);
      },
      onNoClick: (event: any) => {},
    });
  }

  function shippingUI() {
    return (
      <Grid>
        <BakeasyPaper>
          <BakeasyHeaderLabel message={'SHIPPING_MEMOS'} />

          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextFieldSearch
                value={search}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setSearch(event?.target?.value);
                  if (
                    event?.target?.value?.length === 0 ||
                    event?.target?.value?.length > 2
                  ) {
                    refreshPageData(
                      pageNo - 1,
                      event?.target?.value?.length === 0
                        ? undefined
                        : event?.target?.value,
                      filter
                    );
                  }
                }}
                onIconClick={(
                  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
                onEnterClick={(
                  event: React.KeyboardEvent<HTMLInputElement>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
              <div className="tableOptions">
                <BakeasyButtonPrint
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadShippedOrders({ ...filter, downloadType: 'pdf' })
                    );
                  }}
                />
                <BakeasyButtonExport
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadShippedOrders({ ...filter, downloadType: 'csv' })
                    );
                  }}
                />
                <BakeasyButtonFilter
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    openFilterShippingConfirmDialog();
                  }}
                />
              </div>
            </Grid>
          </Grid>

          <BakeasySelectedFilters filter={filter} onDelete={handleDelete} />

          <Grid>
            {shippingList?.length > 0 ? (
              <BakeasyTable
                ref={tableRef}
                pageNo={pageNo - 1}
                search={search}
                headers={shippingTableHeaders}
                tableData={shippingList}
                count={count}
                refreshPageData={refreshPageData}
                filter={filter}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
        </BakeasyPaper>
      </Grid>
    );
  }

  return shippingUI();
};
